export const DataPost = [
  {
    price: '800000',
    name: 'Стрела экг-5',
    description:
      'Стрела Экг-5 в отличном состоянии, на износ не работала, Экскаватор добывал песок на реке в благоприятных условиях.',
    image:
      'photo/metall_tech_74/75_Y0dpiS3Wn3GrjmRuujUJrGLBenDPI0xVbfGkXyXH8us.jpg',
    vendor_code: '696141219807',
  },
  {
    price: '1000',
    name: 'Толкатель клапана Mitsubishi Fuso Fighter 6M61',
    description:
      'Оригинальные толкатели мицубиси фусо фигтер файтер. Толкатель клапана Mitsubishi Fuso Fighter 6M61.',
    image:
      'photo/new_metall/23_eOBMiAtZBPquTQwwi3H9iaa5DSo4q8csPegfLM1aTvA.jpg',
    vendor_code: '657891818969',
  },
  {
    price: '1200',
    name: 'Реле регулятор (зарядки)напряжения',
    description: 'Реле регулятор. Новый! Зима- Лето.',
    image:
      'photo/metall_tech_74/17_o4Dd2HTQ92NX5TXiG3KhRtA6uU5GoOlpUPlK7UmJ4Kc.jpg',
    vendor_code: '233304119550',
  },
  {
    price: '865000',
    name: 'Двигатель weichai wd10g178e25 евро-2 (оригинал)',
    description:
      'Двигатель Weichai Wd10g178e25 Евро-2 (Оригинал).Устанавливается на бульдозеры: Shantui SD16, Yto YD160, Zoomlion ZD160-3, Zoomlion Zd160s-3, Zoomlion Zd160sh-3, Zoomlion Zd160f-5, Foton Fty165-2, Shehwa Hbxg TY165 и др. Торговая марка: Weichai.Модель двигателя: Wd10g178e25.Изготовитель: Weichai Diesel Engine Co., Ltd. Номинальная мощность: 131 квт/ 178 л. С. Номинальное число оборотов: 1850 об/мин.Максимальный крутящий момент: 830 Н·м.Частота вращения крутящего момента: 1100— 1200 об/мин.Евро класс: Евро-2.Объем двигателя: 9,726 литров.Охлаждение: Водяное.Дополнительные характеристики: Уровень шума на 1 м: ≤ 98 дБ(А).Минимальный расход топлива: ≤ 210 г/квт. Ч. Вес нетто: 1000.Вес брутто: 1100 кг.',
    image:
      'photo/metall_tech_74/52_50h3PfNvmkR1HuHNx1NAM7raN1U7CyUXEXOk6x1g34o.jpg',
    vendor_code: '599116725193',
  },
  {
    price: '505',
    name: 'Подшипник игольчатый управляемого моста тсм 15773',
    description:
      'Подшипник игольчатый управляемого моста Тсм 15773.Артикул: 0314613201.Модель (Tcm): FD20/25 C17 / FD20/25 C6 / FD20/25 C6H / FD20/25 T17 / FD20/25 T6 / FD20/25 T6H / FD20/25 W6 / FD20/25 W6H / FD20/25/30 Z5 / FD30 C6 / FD30 C6H / FD30 T6 / FD30 T6H / FD30 W6 / FD30 W6H / FD30 Z7.',
    image:
      'photo/new_metall/10_7WAcVk2LQJ9rTAb9rJnxMiVrp7UgYJAkcZoSbzLdscw.jpg',
    vendor_code: '204170934171',
  },
  {
    price: '410',
    name: 'Подшипник игольчатый мачты INA 80х88х30 дв1792',
    description:
      'Подшипник игольчатый мачты Ina 80х88х30 ДВ1792 Балканкар.Артикул: 205679.',
    image:
      'photo/new_metall/11_62M2JPjO9QDxpQMBffxVuD5_on0KL3FDJU2wMueBfIU.jpg',
    vendor_code: '191962555318',
  },
  {
    price: '851000',
    name: 'Двигатель Yuchai YC6J125Z-T21 для погрузчика',
    description:
      'Новый Двигатель Yuchai Yc6j125z-T21 предназначен для фронтальных погрузчиков. Подходит на погрузчики: Xcmg Lw300kn/Zl30g.— Xgma XG931/XG932.— Hyundai SL730/SL733/sl735iи другие. Характеристики: Мощность (квт) 81.Тип топлива дизель.Крутящий момент (об/мин) 2300.Вес (Кг) 650.',
    image:
      'photo/metall_tech_74/53_ilVHqqn005yjXE1SZsy_5GEYeAkIk8Y8DqHFD9VOw50.jpg',
    vendor_code: '751010190096',
  },
  {
    price: '730000',
    name: 'Редуктор раздаточный ко-605',
    description:
      'Запасные части для шнекороторных снегоочистителей Сшр-1, ДЭ-226, ДЭ-210, КО-605.',
    image:
      'photo/metall_tech_74/15_6HT8BAhyyRyw0iYVgnv0DBMXpl4SnR2JM9P0yyhq5g0.jpg',
    vendor_code: '943388700346',
  },
  {
    price: '3200',
    name: 'Колодка тормозная на полуприцеп чмзап',
    description:
      'Колодка к полуприцепам Чмзап 99859/3502090. Ширина тормозной накладки равна 200 мм. Эта колодка устанавливается в осях на следующих полуприцепах: Чмзап 9906, Чмзап 93853, Чмзап 99065, Чмзап 99064, Чмзап 95201, Чмзап 99859, Чмзап 9911, Чмзап 9990-072, Чмзап 99874, Чмзап 9990-052, а также полуприцепах Тсп (Политранс).',
    image:
      'photo/metall_tech_74/3_dKa4Gj2upZGWiPljrr6OlbxyAc9lj2HvFmtfT_0ID7k.jpg',
    vendor_code: '739743004594',
  },
  {
    price: '3500',
    name: 'Фильтр гидравлический hydac',
    description: 'Фильтра гидравлические почти новые в работе не были.',
    image:
      'photo/metall_tech_74/32_HdB8fd-SInWR0TAM_ViTd01taK_QjO5h7fgx7y4rycw.jpg',
    vendor_code: '981417205346',
  },
  {
    price: '750000',
    name: 'Опорно-поворотное устройство на кс-8165',
    description: 'Опoрно-повоpотнoe yстройствo на кс-8165.',
    image:
      'photo/metall_tech_74/0_T59pLoQSq_bVIeKUzZwhd1ntZBh6NJkAO9TCPBvxH5w.jpg',
    vendor_code: '138215889895',
  },
  {
    price: '950000',
    name: 'Двс ямз 536040-10 метан',
    description: 'Двс ямз 536040-10-11 Газовый Метан!',
    image:
      'photo/metall_tech_74/25_YA_i6zPIpVOgD9O2-fsJKUNN7aQNma3IJpionnUT28k.jpg',
    vendor_code: '664034814396',
  },
  {
    price: '950000',
    name: 'Опорно-поворотное устройство опу-7 (опу-2500)',
    description:
      'Опорно-поворотное устройство Опу-7 (ОП-2500.3.2.16.3. Р. У1) 48 отверстий башенных кранов КБ-308, КБ-309, КБ-401, КБ- 403, КБ-404, КБ-405, КБ-408, КБ-515, КБ-572. Опу диаметром 2500 мм при современных возможностях многих российских машиностроительных предприятий весьма сложно в изготовлении. В первую очередь, у завода должен быть карусельный металлообрабатывающий станок, позволяющий правильно нарезать зубчатый венец Опу при точном соблюдении межцентрового расстояния с шестерней механизма поворота крана и прочих параметров будущего зубчатого зацепления. Такое оборудование имеется далеко не везде, и, как правило, это очень старые советские или немецкие станки, к которым требуется весьма опытный оператор. Во-вторых, понадобятся качественные тела качения опоры для зубчатого венца и полуобойм. В-третьих, многим предприятиям по выпуску деталей машин невыгодно изготовление одного-двух Опу-7, так как проектирование и изготовление оснастки для нарезания зубчатого венца на карусельном станке— уже дорогостоящая операция.',
    image:
      'photo/metall_tech_74/28_31tVGv1RsQLJSDxPCjk2J1HkNrAUeYv9rulnBkXTuuk.jpg',
    vendor_code: '043767607076',
  },
  {
    price: '800000',
    name: 'Сдвижная платформа на ваше шасси в лизинг',
    description:
      'Сдвижная платформа с механизмом фиксации в транспортном положении.· Гидравлическая лебедка 4.1 т с поперечным смещением возможностью фиксации в трех положениях (чехол в комплекте).· Оцинкованный трос 20м.· Фирменные оцинкованные направляющие ролики.· Штатные задние оцинкованные аутригеры.· Гидрокомпоненты производства Италия.· Гидросистема с использованием стальных оцинкованных гидравлических трубок.· Инструментальный ящик пластиковый 500 мм.· Рычаги управления в пластиковом ящике.· Колёсные упоры оцинкованные автовозные (2 шт).· Крепежные ремни (4шт).· Боковая защита алюминиевая с двух сторон.· Защитный короб задних фонарей.· Проблесковый маячок светодиодный (кнопочное подключение).· Диодные контурные огни.· Фонарь освещения рабочей зоны.',
    image:
      'photo/metall_tech_74/81_KMNPHlUMOhvg2eW75aNE4KqqGS93WFt0T6c_TXNvxQQ.jpg',
    vendor_code: '470509861519',
  },
  {
    price: '1330',
    name: 'Фильтр топл. ямз евро-4 тонкой очистки 7511-111707',
    description:
      'Фильтр топливный Ямз Евро-4 тонкой очистки 7511-1117075 (Ямз), производитель Автодизель Ямз.',
    image:
      'photo/metall_tech_74/25_i0xibQotmpqMPbKv5zCDGxj9z2pCldiv3M38GYYZT6E.jpg',
    vendor_code: '297820662080',
  },
  {
    price: '700000',
    name: 'Молот SHD 125 i для экскаватора 16- 24 тн',
    description:
      'Гидромолот Shd 125 i для экскаватора 16- 24 тн. Гидромолот с диаметром пики 125мм и силой удара 4000 Дж.',
    image:
      'photo/metall_tech_74/28_ytyt9xF8c92QuFVO-_ZGdGfNK8ic0ahBa6VzS52_jpE.jpg',
    vendor_code: '900537615852',
  },
  {
    price: '750000',
    name: 'Стрела экг-5',
    description: 'Стрела Экг-5 снятая с экскаватора. В отличном состоянии.',
    image:
      'photo/metall_tech_74/2_ssrw7YeCg6Fl8USZPyX-obscOG0PJ36dShixMMBBK6w.jpg',
    vendor_code: '854581322417',
  },
  {
    price: '1000',
    name: 'Кольца поршневые ямз 236/238',
    description: 'Кольца и пальцы поршневые. Оригинал Новые.',
    image:
      'photo/metall_tech_74/33_NrGz-0Q4gWqWkpTJzfeu7XuH2wwsHc1T1ozwWUtHgho.jpg',
    vendor_code: '383367536778',
  },
  {
    price: '2000',
    name: 'Колодки Камаз',
    description: 'Колодки Камаз.',
    image:
      'photo/metall_tech_74/27_KT4oa3PBfmoAKo5mTg4jWSmEugfxGw35t8L54hv2obM.jpg',
    vendor_code: '795993231068',
  },
  {
    price: '1000',
    name: 'АКПП Volvo A35E 22418',
    description: 'Акпп в отличном рабочем состоянии 22418.',
    image:
      'photo/metall_tech_74/2_1N7335h_4A4D-c7u0OtevOfCdn-6clQeQgDhJRiodDU.jpg',
    vendor_code: '335251770973',
  },
  {
    price: '795000',
    name: 'Кабина трактора Т-150 хта хтз',
    description:
      'Кабина трактора укомплектована: - Удобными регулируемыми сидениями, рулевой колонкой регулируемой по углу наклона и высоте.- Насос-дозатором, распределителем МР-80 гидросистемы навесного оборудования.- Полнокомплектным электрооборудованием (панель приборов, аудиосистема, отопитель, стеклоочиститель ветрового и заднего стекла, светотехнические приборы, электро-жгуты)- Дополнительное сидение для пассажира- Кондиционером с воздушным фильтром забора воздуха кабины.- Зеркалами заднего вида.',
    image:
      'photo/metall_tech_74/82_9E6B3nI6RVe_7kofgMWobjBWvHJS5Pxjp4hxfJ5SmZg.jpg',
    vendor_code: '122690815643',
  },
  {
    price: '500',
    name: 'Прижим колеса к 700',
    description:
      'Продам прижим колеса К-700.Новые 700.31.00.011-3.В наличии.Отправка в регион.',
    image:
      'photo/new_metall/69_o3Yg5080cesiestsRIWqIbpxyUL2n2Y8dPnbCC0h_xs.jpg',
    vendor_code: '512322761824',
  },
  {
    price: '970000',
    name: 'Стенка ковша экг 5а № 1080.52.02 1085.52.03',
    description: 'Стенка ковша экг 5а передняя.Усиленная.',
    image:
      'photo/metall_tech_74/20_W0heR4b8lyLehiLMx2GTTsgeglo7g4XVsNIIxVpSJos.jpg',
    vendor_code: '397048397119',
  },
  {
    price: '500',
    name: 'Ремень безопасности правый Nissan Diesel',
    description:
      'Ремень безопасности правый Nissan Diesel cm87 fe6.Ремень безопасности правый нисан ниссан дизель.В сборе.',
    image:
      'photo/new_metall/33_ec3Da8z8gDSIvUwiIuC2oR6YS3GdAe5Mrj-QsLiEu8Y.jpg',
    vendor_code: '152823687992',
  },
  {
    price: '700000',
    name: 'Двигатель ямз 7511.10-06 №197',
    description:
      'Двигатель Ямз 7511.10-06, 400 Л. С. Двигатель полностью комплектный, со стартером и генератором. Обкатан на стенде под нагрузками. Произведена замена всех Рти. Двигатель С Консервации.',
    image:
      'photo/metall_tech_74/29_recGAjK-TiyykxSak8jj9-Z575Kp6NAlZtAiMVHN1_4.jpg',
    vendor_code: '663874729733',
  },
  {
    price: '750000',
    name: 'Двигатель daewoo DB 58',
    description:
      'Двигатель Daewoo DB58.Состояние идеальное. Подходит и на экскаватор Daewoo Db58ti (Doosan).',
    image:
      'photo/metall_tech_74/1_x0CFBrDy8UceuENNo4oLPYW-hHcqHEW51Pv1S0mzwXY.jpg',
    vendor_code: '687930937649',
  },
  {
    price: '3000',
    name: 'Коренной лист рессоры передней isuzu elf, nissan',
    description: 'Лист рессоры коренной 70мм исузу эльф, Ниссан.',
    image:
      'photo/metall_tech_74/22_N9gmE4rDSSF0UbjjSOGumXf1mSLuz9S6d23XIL_pRbo.jpg',
    vendor_code: '535761689573',
  },
  {
    price: '899000',
    name: 'Двигатель В-31 М2 на Дэт-250 Новый с гарантией',
    description:
      'Двигатель В-31 М2 (М4) к бульдозеру Дэт-250, Дэт-320 в базовой (первой) комплектации. Состояние: новый с хранения.Год выпуска 2012, ревизия (проверка) в 2022.Проведем предпродажное тестирование на стенде. Готов к эксплуатации. Дополнительно возможно к приобретению: - Комплектность вторая «полная» (термостаты, выпускные коллектора, расширительный бочек с трубками): + 90 000р.- Фрикционная муфта: + 135 000р.',
    image:
      'photo/metall_tech_74/44_Teobov1JUxYZ8sAWNnUulUq-Hwha6sb23Xt00D44zKU.jpg',
    vendor_code: '382340688252',
  },
  {
    price: '2100',
    name: 'Фильтр топливный Форд Транзит',
    description: 'Топливный фильтр.Ford Transit. Номер детали 1709059.',
    image:
      'photo/metall_tech_74/37_akUktgpMM875MKvj_SdLC_K_3yuzCP5b6LKS_Tqc9-Q.jpg',
    vendor_code: '475256731502',
  },
  {
    price: '850000',
    name: 'Кабина Скания Scania 5-series',
    description:
      'Кабина Скания.Кабина 2013 года, в таком состоянии как на фото! Дефект: Замятия, видно на фото! Кабина R-серии, Highline, High-line, R— series, 2013 год, Белая.Механика с автоматическим переключением Opticruise, Grs905r— под автоматическое переключение механической коробки переключения передач, Мкпп, механика. Подходит на Scania 5-series R (Сканиа, Скания, 5 серия).・・・.Запчасть б/у. Кабина в сборе.',
    image:
      'photo/metall_tech_74/56_NfA4RgA7brmJr2McWkyB4-YWBefpTccCXuv30l1-0lU.jpg',
    vendor_code: '255003160769',
  },
  {
    price: '670',
    name: 'Подшипник задней ступицы Соболь / Hover передне',
    description:
      'Бренд: Finwhale, артикул: HB621, Подшипник задней ступицы Соболь / Hover передней ступицы внутренний Sobol, Hover H5(05-14), H3(10-14), Safe(01-10) HB621.',
    image: 'photo/new_metall/4_gWMOMNkBOaaO8lswyQ0yAPHEd1uln0G4GmENnmpqlk0.jpg',
    vendor_code: '473321461816',
  },
  {
    price: '3000',
    name: 'Шкворень маз с/о в сб. (к-т на кулак) 500А-3001019',
    description:
      'Шкворень Маз старого образца в сборе (комплект на кулак) 500А-3001019, артикул 500A-3001019, цена 3 000, производитель Маз.',
    image:
      'photo/metall_tech_74/23_-DE8d0gIVz8lfjyJGtHBVQo00fYXIZqVmZXaBQMUNfw.jpg',
    vendor_code: '174319314410',
  },
  {
    price: '700000',
    name: 'Двигатель тмз 8424.10, 8481 / Моторы тмз',
    description:
      'Двигатель Тмз.Описание: — Кол-во цилиндров: 8.— Расположение цилиндров: V8.— Экологический класс: Euro-0.Дизельные двигатели размерности dxs=140140 мм, рабочим объемом 17,24 л,4-тактные, с V-образным расположением цилиндров и турбонадувом, непосредственным впрыском топлива и жидкостным охлаждением.',
    image:
      'photo/metall_tech_74/33_V4hyoYOCphh4clywV01nSLzGBbmLg9FWugBVBCAKfvY.jpg',
    vendor_code: '781669069865',
  },
  {
    price: '320',
    name: 'Прокладка VAG N90467301 N90467301 VAG',
    description: 'Бренд: Vag, артикул: N90467301, Прокладка Vag N90467301.',
    image:
      'photo/new_metall/73_QQQtYjDpHq_CDCRH6eaw_8CDya-P56itYMD4pAV6_Yk.jpg',
    vendor_code: '210855509823',
  },
  {
    price: '900000',
    name: 'Рама с документами камаз 54901',
    description:
      'Рама с документами.Номер производителя: 54901280102021.54901-2801020-21 54901-2801021-21 54901-2801302-20 54901-2801160-20.54901-2801130-20 54901-2801100-20.65956-2801210.54901280102021 54901280102121 54901280130220 54901280116020.54901280113020 54901280110020.659562801210.Рама в хорошем состоянии. Снята с машины 2021 года. Размеры: Длина— 5660мм.Ширина ( Широкая)— 935мм.Ширина ( Узкая)— 770мм.Высота— 285мм.Толщина— 0,9 мм.Рама с документами, доками, с траверсами, поперечинами Птс, рама 54901. Подходит на Камаз 54901 (Kamaz, K 5, K5, К 5, К5).・・・.Запчасть б/у.',
    image:
      'photo/metall_tech_74/41_varsOQpXUAs1e1Z-ehQCL5PVpjMzwqlTvfkByvjbEeU.jpg',
    vendor_code: '011883406780',
  },
  {
    price: '950000',
    name: 'Вал эксцентриковый смд-111',
    description:
      'Вал-эксцентрик 3440.03.001.0023 щековой дробилки Смд-111 / Смд-111А / Смд-111Б.',
    image:
      'photo/metall_tech_74/27_5WX2H0pFf2-QOxoumxbB4jnZ9BHlLVKH18FdfdO8ToU.jpg',
    vendor_code: '255130604779',
  },
  {
    price: '3310',
    name: 'Комплект топливных фильтров JCB',
    description:
      'Фильтр топливный тонкой очистки Jcb 320/07155, 320/07394, 320/07057 Цена:3310.Фильтр топливный грубой очистки 32/925915, 320/A7124.Цена:2650р.Claas Atles 936 RZ, Claas Atles 946 RZ, Claas Atles 926 RZ.',
    image:
      'photo/metall_tech_74/39_ZH8-xYaOkd8Qmr-xegfDPsBhO8zndXU051FmXvCg8lk.jpg',
    vendor_code: '711959843726',
  },
  {
    price: '770000',
    name: 'Двигатель ямз 238м2-6, (240 л.с.) новый',
    description:
      'Двигатель в сборе со сцеплением, Ямз 238м2-6, новый заводской.',
    image:
      'photo/metall_tech_74/92_KvlwOYY06SwOZyU3pIbbH4b2S714lz8pnwDy16ETWyE.jpg',
    vendor_code: '658308986264',
  },
  {
    price: '450',
    name: 'Топливный фильтр 9.3.35',
    description:
      'Топливный фильтр 9.3.35.Волга Крайслер 2.4.Ford Escort, Fiesta, Scorpio.Volvo 940,960, v90.',
    image:
      'photo/new_metall/49_DWphiUxH6S8ZqYDU0eNbYkJqDLcNfaHalmAnFQPYrps.jpg',
    vendor_code: '305565262252',
  },
  {
    price: '500',
    name: 'Воздушный фильтр Цитрон Маз-4370',
    description: 'Воздушный фильтр цитрон зубренок Маз 4370.9.1.32.',
    image:
      'photo/new_metall/39_oZhRZiFKfzLKR4GVBxo87iVBrpfPPA_faGLkgQ3rcpc.jpg',
    vendor_code: '248231203727',
  },
  {
    price: '2300',
    name: 'Палец реактивной штанги в сборе (160мм) чмзап',
    description:
      'Палец реактивной штанги в сборе (160мм) Чмзап 99858-2919030. Характеристики: Длина: 160 мм (180 мм).Диаметр: 50 мм.Применяемость: Балансирная подвеска Чмзап.',
    image:
      'photo/metall_tech_74/4_Vm5FGktG7XR_fhC1eVy0LxTPUAafnK5Hi0CIB9k5hLI.jpg',
    vendor_code: '409016252880',
  },
  {
    price: '900000',
    name: 'Пятимашинник экг-5',
    description: 'Пятимашинный агрегат экскаватора Экг-5.',
    image:
      'photo/metall_tech_74/35_RTvqGgQZGqAJOdsQbZPMNT5Y0Tn9uvKQzTkfR-le87E.jpg',
    vendor_code: '976850217704',
  },
  {
    price: '1700',
    name: 'Комплект крепления запасного колеса schmitz',
    description: 'Комплект крепления запасного колеса schmitz.',
    image:
      'photo/metall_tech_74/24_rVyXdaSfkO9iX6JTVw8gEYiIAfZlfQqd0G4xIkE9j4Q.jpg',
    vendor_code: '697571056090',
  },
  {
    price: '750000',
    name: 'Двигатель Камаз 740.14-300 с кпп',
    description:
      'Новый заводской двигатель на Камаз с кпп в сборе.740.14-300 (Евро 1).Четырёхтактный восьмицилиндровый V-образный дизельный двигатель 740.14-300 выпускается с 2002 года. Устанавливается на автомобили камаз. Тип двигателя: с воспламенением от сжатия.Число тактов: 4.Число цилиндров: 8.Расположение цилиндров: V-образное.Угол развала: 90°.Порядок работы цилиндров: 1-5-4-2-6-3-7-8.Диаметр цилиндра и ход поршня, мм: 120x120.Рабочий объем, л: 10,85.Номинальная мощность брутто, квт (л. С.): 220 (300).Максимальный крутящий момент, брутто, Н·м (кгс·м): 951 (97).Частота вращения коленвала, мин: - номинальная: 2600±50.- при максимальном крутящем моменте: 1500-1800.- на холостом ходу, не более: минимальная: 600±50.Максимальная: 2930.Модель Тнвд: 373-80.01.Модель форсунки: 273-51.Минимальный удельный расход топлива (по внешней скоростной характеристике), г/квт·ч (г/л. С. ·ч): 211 (155).',
    image:
      'photo/metall_tech_74/9_SFPHKL9iqp18z1TFjsYRZqbGssd7r_lui5w-zcduflE.jpg',
    vendor_code: '797809382202',
  },
  {
    price: '700000',
    name: 'Рама поворотная экг-5',
    description: 'Рама поворотная Экг-5. 1080.27.00СБ.',
    image:
      'photo/metall_tech_74/26_rmcHZtV_bVdmjekZjVRba6vY_fUBOOq3J_DhLst2rag.jpg',
    vendor_code: '736821536066',
  },
  {
    price: '1000',
    name: 'Обшивка потолка кабины Nissan Diesel CM87',
    description:
      'Обшивка потолка кабины Nissan Diesel CM87.Обшивка салона Nissan Diesel.Обшивка кабины Nissan Diesel.Обшивка потолка кабины ниссан дизель.Обшивка салона нисан дизель.Обшивка кабины ниссан дизель.',
    image:
      'photo/new_metall/67_e0cM3pDcU5RAV7nybg5r5R427hKqYOtROKHtS-BkTzk.jpg',
    vendor_code: '131175399863',
  },
  {
    price: '2500',
    name: 'Подкрылки Урал',
    description:
      'Подкрылки для, а/м Урал.Подходят для Урал 375, 4320, 5557, 55571 и другие. Цена за шт.',
    image:
      'photo/metall_tech_74/36_zThfnlnt27cU0Asc0AkUJ8OMo0cBDq3CIa8TDrUeTCE.jpg',
    vendor_code: '476421256102',
  },
  {
    price: '790000',
    name: 'Двигатель ямз 238 де2',
    description:
      'Двигатель Ямз 238ДЕ2 8-цилиндровый дизельный двигатель с V-образным расположением цилиндров, 4-тактный, с непосредственным впрыском топлива, жидкостным охлаждением. Это двигатель после капитального ремонта, состояния нового, без стартера и генератора, с применением оригинальных запасных частей и качественных аналогов. Спецификация основных узлов: 1. Цилиндра-поршневая группа— новая Ямз.2. Насос масляный— новый Тмз.3. Насос водяной— новый.4. Головка блока— восстановленная(сертифицированный центр).5. Коленчатый вал— восстановленный (К-1, Ш-1) 6. Генератор— новый.7. Форсунки— восстановленные (распылители новые).8. Фильтра, прокладки, кольца, втулки, топливопроводы и т. Д. Двигатель прошел обкатку на стенде. Без К/П И Сцепления.Мощность: 330 л. С.. Масса: 1260 кг.',
    image:
      'photo/metall_tech_74/85_HrdlO-uaFFxEySrchKFjbV40vCodJTWCsClNlNmQdlQ.jpg',
    vendor_code: '637429943343',
  },
  {
    price: '130',
    name: 'Ролик сдвижной крыши 24 мм под гайку',
    description:
      '— Ролик для сдвижной крыши Krone 24 мм под гайку. Новые в наличии. Также в наличии и другие ролики сдвижных крыш. Отправлю в регионы.',
    image:
      'photo/new_metall/72_dYMiYSmZA9GZiw3jQcXtOHxchFpR7fq2zX2TzEIQLx0.jpg',
    vendor_code: '060823121281',
  },
  {
    price: '814000',
    name: 'Двигатель ямз-240нм2 (Карьерный самосвал белаз)',
    description:
      'Двигатель ЯМ3-240НМ2 (Карьерный самосвал Бела3).Мощность, л. С.: 500.Мощность, квт: 368.Частота вращения, мин-1: 2100.Макс. Крутящий момент, Н. М1815.Частота при макс. Крут. Моменте, мин-1: 1600.Мин. Уд. Расход топлива, г/квт. Ч: 208.Габаритные размеры, мм: 1764/1104/1194.Масса, кг: 1794.Область применения двигателей: Карьерные самосвалы гру3оподъемностью 42 т бела3-75485.Производитель: Ямз.Артикул: Krn-344.',
    image:
      'photo/metall_tech_74/73_mAMYg32Z9A3c74WKppcSCuGBYGH6j1VvSgBxdKBR1IU.jpg',
    vendor_code: '964287377309',
  },
  {
    price: '900000',
    name: 'Эвакуаторная сдвижная платформа',
    description:
      'В комплектации.1)гидравлическая лебедка. 2)Задние аутригеры. 3)контурная подсветка (fristom).4)Освешение рабочей зоны. 5)инструментальный яшик. 6)проблесковый маячок( балка).7)цвет любой на выбор. 8)сталь 3мм (гост).9)усиленные петли для крепежа автомобиля.',
    image:
      'photo/metall_tech_74/37_E4wDEorKONSkzumsYRgtMXQOJnKwLiaroFKVFusnm38.jpg',
    vendor_code: '169005780981',
  },
  {
    price: '906760',
    name: 'Псу в сборе100.44.000-01 Витязь дт-30',
    description: 'Псу в сборе 100.44.000-01 Витязь ДТ-30.',
    image:
      'photo/metall_tech_74/34_N1SYp0YPpGnj-iAhN_VIKZtIxImPxdSCYfWlYD2nvjg.jpg',
    vendor_code: '351843498178',
  },
  {
    price: '500',
    name: 'Приводной ремень 10.1.34 Волга Крайслер 2.4',
    description:
      'Приводной ремень 10.1.34.Волга 3110 Крайслер 2.4, Ford Fiesta, Volvo s40, s90, v40. V90.Volkswagen Passat, Transpoter, Golf 2.',
    image:
      'photo/new_metall/50_0CeU2rjEZ7zuM07FHekC5uNUcbgawRREsIZbi8fqxZI.jpg',
    vendor_code: '528163425657',
  },
  {
    price: '900000',
    name: 'Рама и псм грейдер Volvo G946',
    description: 'Рама с Псм грейдер Volvo G946 в отличном состоянии.',
    image:
      'photo/metall_tech_74/36_LB0uTciY44G6vfR81P5ZztdoKvWZbikJnZX5QTiFl8I.jpg',
    vendor_code: '837002303869',
  },
  {
    price: '700000',
    name: 'Двигатель Д-180',
    description:
      'Двс для тракторов Т-170, Б10, Б10М, Б10мб. Двигатель Д-180 после капремонта в ходе которого было восстановлено 100% моторесурса, новый Д-180.',
    image:
      'photo/metall_tech_74/27_ZU4bCXkAEmez2PUZu7PM5HwUMiIjhFdRQCKx29eFY5g.jpg',
    vendor_code: '665315553869',
  },
  {
    price: '990000',
    name: 'Гусеница вездехода ттм с уширителями',
    description:
      'Гусеница к вездеходам Ттм с двусторонними уширителями, 184 звена. Гарантия производителя. Цена с Ндс.',
    image:
      'photo/metall_tech_74/7_J33O9OXVX0WApjsKtnm4QttA3EzjXRodIBmDactCcZE.jpg',
    vendor_code: '664369086923',
  },
  {
    price: '700000',
    name: 'Новая раздаточная коробка cargo TC 1100 Iveco',
    description: 'Раздаточная коробка TC 1100 Iveco Eurocargo, новая.',
    image:
      'photo/metall_tech_74/31_m0xgYY7eUjHjg9szqrmrYsa6Q41_iX3GeZch7AMJyHg.jpg',
    vendor_code: '249349874181',
  },
  {
    price: '750000',
    name: 'Двигатель камаз 740.62 Евро -3 в сборе №1/2/5',
    description:
      'Дизельный восьмицилиндровый двигатель Камаз 740.62-280 мощностью 280 л. С. Экологического стандарта Евро-3, с турбонаддувом, подходит для автомобиля Камаз 65111, 65115, 65116, 65117, 6540 и др.',
    image:
      'photo/metall_tech_74/4_MrCsxS15ArS5YQaoFC3RgjHz1b08nKAiWE8j_GMThvs.jpg',
    vendor_code: '187551140312',
  },
  {
    price: '712500',
    name: 'Двигатель ямз 240бм2-1 №5011719',
    description: 'Двигатель Ямз 240БМ2-1 (300 л. С.).',
    image:
      'photo/metall_tech_74/24_rGXHg9HdKSGatEQ0RF0A_44bpJrs9HEqeBaThZTFs1o.jpg',
    vendor_code: '126708713750',
  },
  {
    price: '800000',
    name: 'Кабина Ман Man TGX',
    description:
      'Кабина Ман.81623076447 81623076326 81621596366 81258087064 81258067103 81521306298.Кабина 2011 года, в отличном состоянии! Кабина высокая, широкая 2011 год, Акпп.Автоматическую коробку переключения передач, автомат, в отличном состоянии. Подходит на Man Tgx I (Ман, Мэн, Тгх).',
    image:
      'photo/metall_tech_74/79_RU_66rpHJgpqiWCWt5j3izrFY4dtgl2JK9NMGrbGGUo.jpg',
    vendor_code: '162906861436',
  },
  {
    price: '996950',
    name: 'Клешни /захват для экскаватора 320го',
    description: 'Новые в идеальном состоянии!',
    image:
      'photo/metall_tech_74/4_IyFVH1kfweft-s2wdju9BhcZVIbLRhLmxUazll6NVb4.jpg',
    vendor_code: '703415457056',
  },
  {
    price: '800000',
    name: 'Двигатель ямз 240бм2-4 хранение №049',
    description:
      'Двигатель Ямз 240БМ2-4, 300 Л. С. Двигатель полностью комплектный, со стартером и генератором. Обкатан на стенде под нагрузками. Произведена замена всех Рти. Двигатель С Консервации.',
    image:
      'photo/metall_tech_74/77_oAaUtTnfBRB5Z7jTdDfprTLDJVmcjewYEMKSqL1DIIM.jpg',
    vendor_code: '151763364551',
  },
  {
    price: '950000',
    name: 'Будка вахтовка кузова',
    description:
      '28 мест. Кузов закрытый фургонного типа, каркасного типа, с термоизоляцией 60 мм., стены и потолок отделаны сверхпрочным, небоящимся жидкостей и повреждений Стеклопластиком, по правой боковине вахта снабжена двумя дверями, одна из них аварийная.- Сиденья автобуса— пассажирские, двухместные с трехточечными ремнями безопасности.- Двери— одинарные, открываются наружу по ходу движения.- Окна— двойные, остекленные закаленным стеклом.- Система отопления: основная от 2-х автономных Планар с дисплеем и пультами ДУ, работающего на дизтопливе; в также 2-х тосольников с подключением жидкостной системы охлаждения двигателя к основной системе отопления. - Вентиляция: естественная— через люки крыши; принудительная— от вентилятора в люке, установленного на крыше кузова.- Вахтовка оснащена транспортным переговорным устройством.',
    image:
      'photo/metall_tech_74/24_BBbGZFX8lcKxAYZSV3xft7q_LeVDemcNQUjkqF3Wm8I.jpg',
    vendor_code: '602565782015',
  },
  {
    price: '800000',
    name: 'Кабина jac n75 n80 n90 n120',
    description: 'Подходит на камаз компас(compass).Кабина jac n120.',
    image:
      'photo/metall_tech_74/76_p3ggbPjJhrKgNQtm4GS87_c9Fix5anXmTqaZZDbHqiM.jpg',
    vendor_code: '386998200900',
  },
  {
    price: '851000',
    name: 'Profbreaker PB 250h на экскаватор',
    description:
      'Гидромолот Profbreaker PB 250h. Характиристики: Диаметр инструмента, мм— 135.Масса гидромолота, кг— 1840.Энергия удара, Джоуль— 5780.Назначение— Гидромолот на экскаватор.Давление гидросистемы, бар— 160~180.Давление предохранительного клапана, атм— 210.Масса экскаватора— 18-26.Поток масла, л/мин— 125~150.Примечание— Гидромолот закрытого типа, малошумный, премиум.Частота ударов, уд-мин— 400~800.',
    image:
      'photo/metall_tech_74/54_VQBqXBENYOv4WURtQhKjiZ8eHXRS2NjEz8Z3df6VfY4.jpg',
    vendor_code: '578160571821',
  },
  {
    price: '700000',
    name: 'Мост задний погрузчик Volvo L220E,F,G',
    description:
      'Мост задний для фронтального погрузчика volvo l220 E, F, G в отличном состоянии. Voe 11102156, voe 23883.',
    image:
      'photo/metall_tech_74/35_4ji7XD8UDpJYKO5bicJf6ke0VV2x4K5D96oeCj_JeTY.jpg',
    vendor_code: '866085631198',
  },
  {
    price: '1000',
    name: 'Двигатель Hino Dutro N04C-T в разборе',
    description:
      'Двигатель Hino Dutro N04C-T.Проается по запчастям контрактный двигатель хино дутро No4c n04c н04ц. Цены и наличие запчастей узнавайте отдельно!',
    image:
      'photo/new_metall/15_2dEJW_ycasmeOmyks-KIsd6jmPLMXL4ZhE3EntWiJx0.jpg',
    vendor_code: '140272588973',
  },
  {
    price: '810000',
    name: 'BJ493zlqv1-AR1 Двигатель Дизельный',
    description:
      'Двигатель Дизельный.Новый. Оригинал. Гарантийный. Предназначен для самоходного разбрасывателя удобрений «Туман-2М».Характеристики.4 цилиндра, 3 такта, дизель.Диаметр цилиндра, Ход поршня: 93х102 мм.Степень сжатия: 18,2:1.Объём рабочий: 2,771 л.Порядок работы цилиндров: 1-3-4-2.Направление вращения: против часовой стрелки со стороны маховика.Мощность: 72 квт или 97 л. С. При 3600 об/мин.Крутящий момент: 220 Нм при 2300 об/мин.Расход топлива: 221 г/квт*ч.Воздухоподача: турбонаддув.Топливоподача: пучковый Тнвд, механические форсунки.Экология: Евро-2.Габариты (дхшхв): 734х612х682 мм.Вес: 251 кг.',
    image:
      'photo/metall_tech_74/74_XsFHRF7HtFwrbBHqeinoU5EOPPdISFRXTzrr3mtQYH4.jpg',
    vendor_code: '268014767808',
  },
  {
    price: '2500',
    name: 'Наконечник рулевой Hyundai HD78',
    description:
      'Наконечник рулевой левый HD78 568805K000.Наконечник рулевой правый HD78 568905K000.Новый производство Япония качество оригинала.',
    image:
      'photo/metall_tech_74/5_vR3A8KvyrRIyWGyMGD51ehxt5syQs9NGGLTjHXmmncY.jpg',
    vendor_code: '660142121283',
  },
  {
    price: '750000',
    name: 'Гидронасос основной Komatsu PC300-8',
    description:
      'Гидравлический насос основной для экскаватора Komatsu PC300-8. Каталожные номера: 708-2G-01070, 708-2G-00700, 708-2G-00180, 708-2G-01180, 708-2G-01074.Восстановленный вариант: оригинальный корпус б/у с окрасом; полностью новый качающий узел (handok, Южная Корея); новые подшипники, сервопоршни, LS-клапана, датчики управления (соленоиды)— оригинал Japan. Насос проверен на гидравлическом стенде и настроен на показатели, предусмотренные заводом изготовителем.',
    image:
      'photo/metall_tech_74/5_E4Y8S_rn22SXOo4xx_PAYqOkVgnCq9uIdpIjiN2eIgY.jpg',
    vendor_code: '873824630372',
  },
  {
    price: '4000',
    name: 'Рулевая колонка на мтз',
    description: 'Рулевая колонка на мтз.',
    image:
      'photo/metall_tech_74/20_2bgOvv2pBEeXvdY7LuRYtMUkF4LLJw0c9xAlMcxTAeg.jpg',
    vendor_code: '149832884632',
  },
  {
    price: '800',
    name: 'Ресничка Isuzu Elf правая',
    description:
      'Без повреждений. Ресничка Nkr81e Isuzu Elf.Накладка на фару nkr81e isuzu elf.Ресница nkr81e isuzu elf.Ресничка исузу эльф.Накладка на фару исузу эльф.Ресница исузу эльф.',
    image:
      'photo/new_metall/65_Uh9ar4OgWrFnCp4dOCHGArwkAWi6TZgtQgzHcv7YLQ0.jpg',
    vendor_code: '947524356622',
  },
  {
    price: '2200',
    name: 'Кронштейн (ручка подпятника полиамидного)',
    description:
      'Ручка для полиамидных подпятников с креплением на 2 болта. Подходит для стандартной пяты из полиамида для автокранов Галичанин, Ивановец, Клинцы и др.',
    image:
      'photo/metall_tech_74/31_fS0eKCt6-uhGBxSXWo0XaEtGjvjqwl2okQps8IJqxtw.jpg',
    vendor_code: '049379272116',
  },
  {
    price: '500',
    name: 'Отбойник передней рессоры Isuzu Elf',
    description: 'Отбойник передней рессоры исузу эльф.',
    image:
      'photo/new_metall/14_Bu4q2IoE1g93fuGWLSHPyEMUl2IOYkK6zue-UypTLqI.jpg',
    vendor_code: '955636348297',
  },
  {
    price: '3950',
    name: 'Гидроцилиндр гц 50.25.400.605.025',
    description:
      'Гидроцилиндр ГЦ 50.25.400.605.025. Г/ц подъёма косилки Крп-302, пресс-подборщик Ппр-120.Гидроцилиндр ЦС-50.25.400.605.025 Ппр-120, Прф-160, Крп-302. Технические характеристики.Диаметр поршня, мм. 50.Диаметр штока мм. 25.Ход штока мм. 400.Расстояние по центрам, мм. 605.Диаметр пальца, мм. 25.Толкающее усилие, кг. 3900.Тянущее усилие, кг. 2900.Максимальное давление, mpa 20.Номинальное давление, mpa 16.Скорость, м/с 0,5.Рабочий объем, л 0.79.Вес, кг. 7,2.',
    image:
      'photo/metall_tech_74/34_ctu0z_w662yko266Hjqm8VQ7N5Vw4Sbxrt8HtbGd5pw.jpg',
    vendor_code: '260098348544',
  },
  {
    price: '800000',
    name: 'Кузов самосвал камаз 6520',
    description:
      'Полный комплект самосвальной установки 6520 (надрамник, кузов, Ком, гидропривод, цилиндр подъёма, тент).20 кубов. Март 2023 г. В.',
    image:
      'photo/metall_tech_74/80_oRnHsA8BKxM9OaWrSFrJbrspvNJ21sJ2HL76amMmAsc.jpg',
    vendor_code: '338987177996',
  },
  {
    price: '980000',
    name: 'Двигатель Камаз 740.31 Евро от производителя №232',
    description:
      'Двигатель 740.31 Евро-2 для автомобилей камаз Двс 74031. Агрегат собран в полном соответствии с требованиями завода-изготовителя, проверен на стенде. Каждый агрегат сопровождается полным пакетом документов, а также паспортом сборки в котором указаны все комплектующие использованные при сборке. Данный блок устанавливается на автомобили камаз таких моделей как Евро 53125 53205 5511 43105 55102 6520 6460 54115 65115 65116 53213 65226 53229 53228 65201 65222 5511 65221 4310 4308 43118 43115 45141 54112 5410 53215 65225 45144 6522 43118 53212 65111 5320 45142 65117 45143.Артикул запчасти на фото №111-222323-16188.',
    image:
      'photo/metall_tech_74/14_jvpz2M9bwhU5lgKkuOvpMVtXoSXu16EGEUmttdK_Plk.jpg',
    vendor_code: '405458256145',
  },
  {
    price: '400',
    name: 'Воздушный фильтр NF-4503',
    description:
      'Воздушный фильтр nf-4503.Невский Фильтр Nf-4503 Газель.Дв. Змз-406- Инжектор.Газ-560.Новый фильтр.',
    image:
      'photo/new_metall/53_kfPQ5RSHIyp6CidM75PSAPVITRqjGkX6UgeAUmtERV0.jpg',
    vendor_code: '709893840707',
  },
  {
    price: '785000',
    name: 'Кпп 6WG180',
    description: 'Кпп В Сборе 6WG180. Совместима с Xcmg GR215, liugong Clg418.',
    image:
      'photo/metall_tech_74/87_wmVlf_a43MtycHSm2etlHtGkxlvSgoxqERKNcmjQOLY.jpg',
    vendor_code: '533688692910',
  },
  {
    price: '830000',
    name: 'Шайба магнитная М117',
    description:
      'Магнитная шайба М117 с преобразователем напряжения Дпн 125., с цепями. Эксплуатировалась 7 месяцев.',
    image:
      'photo/metall_tech_74/66_HND_H_Cmh3KM7YqCdxpmdioIQM3Uew1fo0U1M7Qy4s0.jpg',
    vendor_code: '516485224862',
  },
  {
    price: '837000',
    name: 'Двигатель ямз-240М2 белаз',
    description: 'Двигатель Ямз-240М2, 360 л. С. Для самосвалов Белаз.',
    image:
      'photo/metall_tech_74/64_TcuFo6I-fONp1MRKgwVIm0d-9_TgvyT0nE9hT1rEW_w.jpg',
    vendor_code: '479146285952',
  },
  {
    price: '1800',
    name: 'Тормозные цилиндры Урал 5557',
    description: 'Новые Тормозные цилиндры Урал 5557',
    image:
      'photo/metall_tech_74/30_p7HVZeUEmlhtb9nKM_dSXLBnxV-4tCgPeaWWknvbjh4.jpg',
    vendor_code: '189594647203',
  },
  {
    price: '875000',
    name: 'Двигатель мерседес-бенс 2013 года',
    description: 'Двс Mers OM 501 LA. В отличном состоянии. Пробег 300 т. Км.',
    image:
      'photo/metall_tech_74/50_gebgNSM04D3-SdRjyPPD9kZT3gU_5w1on2b7Ze1LwpQ.jpg',
    vendor_code: '030628057701',
  },
  {
    price: '3500',
    name: 'Механизм переключения передач 18-12-178сп',
    description: 'Новые, не были в использовании.',
    image:
      'photo/metall_tech_74/0_ESZCAeyIB1Eijazd2g8KUCKNSCVPxMMkxlJLAk8cSQo.jpg',
    vendor_code: '669789950946',
  },
  {
    price: '730000',
    name: 'Дэ-210 редуктор раздаточный',
    description:
      'Редуктор раздаточный ДЭ-210Б.07.01.000 для снегоочистителя шнекороторного ДЭ-210, КО-605, Д-407.',
    image:
      'photo/metall_tech_74/16_OpZMEHRX2zvnDUg-QZWSLmYotlGhEBQPHbmwNVW5B5o.jpg',
    vendor_code: '612201870167',
  },
  {
    price: '900000',
    name: 'Двигатель в сборе 4hk1 евро4 Isuzu fsr90',
    description:
      'Двигатель в отличном состоянии на Isuzu fsr90 4hk1 евро4, пробег 180 000 км.',
    image:
      'photo/metall_tech_74/42_sHdkWlHYCofGiAbh5LH5FGnMKx9jngQi-cjtcMLRI9Y.jpg',
    vendor_code: '570662127312',
  },
  {
    price: '700',
    name: 'Топливный фильтр NF-2110G',
    description:
      'Топливный фильтр NF-2110G.Топливный фильтр NF-2110G.Газ волга Инжектор(3102,3110;Газель, соболь(змз 406)).Новый фильтр. Возможность взять оптом 39 штук.',
    image:
      'photo/new_metall/55_kkpcz-Aar7r5eh0aA_ppp3aEJlfSDk4GN_5o6MX3boc.jpg',
    vendor_code: '863605986938',
  },
  {
    price: '550',
    name: 'Фонарь габаритный FT-073 B LED - белый',
    description:
      'Фонарь габаритный Fristom FT-073 B Led— белый. Польский габаритный фонарь Fristom (Фристом) FT-073 B Led. Фонарь габаритный белый с проводом. Продукт оснащен пластмассовыми колпачками на крепежные винты давая ему профессиональный имидж. Интересное и уникальное излучение света. — 1— функциональный фонарь типа Led— низкое энергопотребление: Свет габаритный— белый. — Фонарь с проводом 0.15 м и сечением провода 2 х 0.75 мм2;— Прокладка резиновая чёрная для монтажа фонарей на плоскостях и круглая для монтажа фонарей на трубах транспортных средств. — Европейский сертификат E9;— Сертификат электромагнитной совместимости— Emc;— Конструкция фонаря устойчивая к механическим повреждениям;— Фонарь защищён от переменной полярности питания. Параметры фонаря FT-073 B Led: — Напряжение питания: 12-36 В DC;— Диапазон рабочих температур окружающей среды от— 40°C до +55°C;— Фонарь устойчивый к атмосферным воздействиям;— Фонарь герметичен. Параметры фонаря: Вариант крепления- Без кронштейна.Источник света- Светодиоды.Форма фонаря- Прямоугольный.Тип- Габаритный фонарь.Функция- Габаритный свет.Герметичность- Герметичный фонарь.Напряжение питания 12-36 В DC.Свет- Белый Led.Диапазон рабочих температур окружающей средыот— 40°C до +55°C.Потребляемая мощность (номинальная мощность)12В/24В = 0,6 Вт/ 1,2Вт.',
    image:
      'photo/metall_tech_74/21_uLKu9KyMXIOZaY-NohEIkt-Q9_omV6ZEinih-sPvwac.jpg',
    vendor_code: '968526571170',
  },
  {
    price: '170',
    name: 'Салфетка Микрофибра 42х64 см CityUP CA108 City Up',
    description:
      'Бренд: City Up, артикул: CA108, Салфетка Микрофибра 42х64 см cityup.',
    image:
      'photo/new_metall/76_htEwHfxO1Zw40xwy-ei3c26gZmgHFYCnwOlImOwR3Ls.jpg',
    vendor_code: '599767354142',
  },
  {
    price: '980000',
    name: 'Двигатель Камаз 740.31 Евро от производителя №532',
    description:
      'Двигатель 740.31 Евро-2 для автомобилей камаз Двс 74031. Агрегат собран в полном соответствии с требованиями завода-изготовителя, проверен на стенде. Каждый агрегат сопровождается полным пакетом документов, а также паспортом сборки в котором указаны все комплектующие использованные при сборке. Данный блок устанавливается на автомобили камаз таких моделей как Евро 53125 53205 5511 43105 55102 6520 6460 54115 65115 65116 53213 65226 53229 53228 65201 65222 5511 65221 4310 4308 43118 43115 45141 54112 5410 53215 65225 45144 6522 43118 53212 65111 5320 45142 65117 45143.Артикул запчасти на фото №111-222323-18168.',
    image:
      'photo/metall_tech_74/13_Q6MfJ8AxzANsxZwsFbrj7ISYERu56qpV-6HGOv8QLd0.jpg',
    vendor_code: '483847408820',
  },
  {
    price: '500',
    name: 'Стремянка рессоры Isuzu Elf передняя',
    description:
      'Стремянка рессоры исузу эльф передняя.Стремянка рессоры Isuzu Elf передняя.Подберем по вашим размерам.',
    image:
      'photo/new_metall/16_oPNqPkRCvwkrqM62TVJx9N36QeKMLA7K4BOmdIrGlBc.jpg',
    vendor_code: '937931459624',
  },
  {
    price: '850000',
    name: 'Стрела для дэк-50',
    description:
      'Стрела крановая на Дэк-50 с гуськом. Основание стрелы (корень)— 13,2м, вставка 5м— 2 шт., вставка 13м— 1 шт., оголовок 2м.',
    image:
      'photo/metall_tech_74/59_2cvgiE-YIKrmJATJvuA0uB8KIfvcAd0LlOaf4GxZ024.jpg',
    vendor_code: '778353550913',
  },
  {
    price: '980000',
    name: 'Двигатель Камаз 740.31 Евро от производителя №132',
    description:
      'Двигатель 740.31 Евро-2 для автомобилей камаз Двс 74031. Агрегат собран в полном соответствии с требованиями завода-изготовителя, проверен на стенде. Каждый агрегат сопровождается полным пакетом документов, а также паспортом сборки в котором указаны все комплектующие использованные при сборке. Данный блок устанавливается на автомобили камаз таких моделей как Евро 53125 53205 5511 43105 55102 6520 6460 54115 65115 65116 53213 65226 53229 53228 65201 65222 5511 65221 4310 4308 43118 43115 45141 54112 5410 53215 65225 45144 6522 43118 53212 65111 5320 45142 65117 45143.',
    image:
      'photo/metall_tech_74/11_1eFGMaG2R2elQwaPEsEnzqBqUo4abIpUPdDiiZbHyvs.jpg',
    vendor_code: '598118291593',
  },
  {
    price: '750000',
    name: 'Двигатель камаз 740.62 Евро -3 в сборе №1522',
    description:
      'Дизельный восьмицилиндровый двигатель Камаз 740.62-280 мощностью 280 л. С. Экологического стандарта Евро-3, с турбонаддувом, подходит для автомобиля Камаз 65111, 65115, 65116, 65117, 6540 и др.',
    image:
      'photo/metall_tech_74/6_U82HAanAx0nCgqYsmC5v-PmUqS0CBoM0HItRWYFGfZQ.jpg',
    vendor_code: '029675001039',
  },
  {
    price: '950000',
    name: 'Двигатель камаз 740.62 Евро -3 в сборе №1/2/3',
    description:
      'Представленная модель двигателя, дизельный восьмицилиндровый двигатель Камаз 740.62-280 мощностью 280 л. С. Экологического стандарта Евро-3, с турбонаддувом, подходит для автомобиля Камаз 65111, 65115, 65116, 65117, 6540 и др.',
    image:
      'photo/metall_tech_74/26_GgNjBt0Vw2_gV5WjqJZ3vWvqYuLwq1j3qBG--AZN9rQ.jpg',
    vendor_code: '685934989490',
  },
  {
    price: '849000',
    name: 'Урал 4320 лесовоз',
    description:
      'Маш. Комплект, а/м Урал 4320 Лесовоз.Комплектация: - Рама, усиленная под лесовоз (усилители внутренние 8 мм, наружные нижние за кабиной под Кму 8 мм) с полной пневмо и электро-обвязкой (трубки, Пгу 3шт (на каждый мост), рессивера, краны, электропроводка, силовые провода, шланги, ящик Акб, Рти, датчики).- Раздаточная коробка с ручником и Кдом.- Рессоры усиленные задние 15л— 2шт.- Рессоры передние крановые 11л— 2шт.- Ось балансира с башмаками в сборе усиленная.- Штанги реактивные комплект из 6шт.',
    image:
      'photo/metall_tech_74/62_GbkfJwy43fzXQ3vGy9PivbKi0_GNDHrSxgIzE7BA2V4.jpg',
    vendor_code: '061903926651',
  },
  {
    price: '900',
    name: 'Топливный фильтр NF-2116',
    description:
      'Фильтр Топливный Невский Фильтр Nf-2116.Hyundai Accent 00-, Kia Rio 2007-.Для хюндай аксцент, киа рио.Новые фильтры.',
    image:
      'photo/new_metall/52_H9NvkhaLpSYDHqCH1VYVHreByEyYD5_3PpakZ8FvnqA.jpg',
    vendor_code: '404533843054',
  },
  {
    price: '710',
    name: 'Фильтр масляный на двигатель 4Y/5K',
    description:
      'Фильтр масляный на двигатели 4Y/5K Toyota.Артикул: 809157601271.',
    image:
      'photo/new_metall/12_AkDObc7lrE-LlfvseP846-5ExoNyTn1G98Aoqladbrg.jpg',
    vendor_code: '853514099094',
  },
  {
    price: '700000',
    name: 'Двигатель wd615',
    description: 'двс wd615.',
    image:
      'photo/metall_tech_74/36_NTpuxFc77lXM6GPkVJOyM4HTnubtdNvUG0RAA_5DQ8g.jpg',
    vendor_code: '897974691655',
  },
  {
    price: '3900',
    name: 'Тяга поперечная Урал 4320',
    description:
      'Тяга рулевой трапеции в сборе, поперечная (Усиленный палец) 5557-3414052-10.',
    image:
      'photo/metall_tech_74/8_Xuo4277HQtBbIG6GEj0qQXW4h-M-2oGUZTcytuRpiUM.jpg',
    vendor_code: '348276474145',
  },
  {
    price: '1000000',
    name: 'Молот SHD 155 i для экскаватора 28-35тн',
    description:
      'Гидромолот 155i.Вес экскаватора, т: 28-35.Вес гидромолота, кг: 2406.Высота (с пикой), мм: 3155.Расход масла, л/мин: 180-240.Диаметр пики, мм: 155.Рабочее давление, бар: 160-180.Частота удара, уд/мин: 300-450.Энергия удара, Дж: 8925.Артикул: Stu-295.Номер партии: dgvg56959.',
    image:
      'photo/metall_tech_74/3_y1nCAsy-OWHvH3Fygnw3oy1bDpwJJP7Dizi2My7ZXhg.jpg',
    vendor_code: '165619208701',
  },
  {
    price: '2000',
    name: 'Бак топливный Урал 4320',
    description: 'Топливный бак 200 литров. Урал. Состояние хорошее.',
    image:
      'photo/metall_tech_74/13_Fu8uNGnYPjQ6XUdb5mUracjKaGpYU913aAJAHT3A-qg.jpg',
    vendor_code: '433997176804',
  },
  {
    price: '900000',
    name: 'Акб 80V 500Ah CPD 30',
    description:
      'Совместим с погрузчиками следующих брендов: Jac, Heli, Dalian, HC, Maximal, Hangcha, Tfn, Lonking.Акб 80V 500Ah Cpd 30.',
    image:
      'photo/metall_tech_74/43_wJJCWuOU432HZT6oXjRbwSnglJOtzgzsW9Hgs9RThMU.jpg',
    vendor_code: '549013545686',
  },
  {
    price: '750000',
    name: 'Колесо центральное Z108 M10 3532.09.00.013',
    description: 'Колесо Центральное Z=108 M=10 3532.09.00.013.',
    image:
      'photo/metall_tech_74/7_hRCtV5852S1ayR9656NHNG8Im_cDnzdpmjZwIoPoTbE.jpg',
    vendor_code: '792057825078',
  },
  {
    price: '700000',
    name: 'Стрела экг5 в сборе',
    description: 'В наличии стрела экг5 в сборе.',
    image:
      'photo/metall_tech_74/32_kCC3Mr-rJFbR2MaTBQ1fpUe7BZh-De5gUK9LFbk9AHo.jpg',
    vendor_code: '012314085291',
  },
  {
    price: '900000',
    name: 'Молот SHD 140 для любых экскаваторов 18-26 тн',
    description:
      'Гидромолот Shd 140 для любых экскаваторов 18-26 тн. Гидромолот с диаметром пики иаметр пики, 140 мм и силой удара 5372 Дж. Характеристики: Модель экскаватора, т 18-26.Вес гидромолота, кг 1656.Высота (включая пику), мм 2828.Расход масла, л/мин 120-180.Рабочее давление, бар 160-180.Частота удара, уд/мин 350-500.Артикул: Dar-437.Номер партии: JD117639.',
    image:
      'photo/metall_tech_74/38_G4XpscyyNH4Xffm9FowQGGRUE8dQljOaZZ04Obu3nn4.jpg',
    vendor_code: '464764682364',
  },
  {
    price: '500',
    name: 'Стеклоподъемник правый Toyota Corolla AE110',
    description:
      'Стеклоподъемник правый Toyota Corolla AE110.Стеклоподъемник правый тойота королла.',
    image:
      'photo/new_metall/62_6Uz1kggnEIDEUppJj9sJSfWjlaprq_9B-L7zPx-c424.jpg',
    vendor_code: '588423679114',
  },
  {
    price: '1300',
    name: 'Крыльчатка вентилятора ямз-236',
    description:
      'Крыльчатка вентилятора Артикул: 238НБ-1308012-Б2 Состояние: Новый(уценен из-за трещины на 1-ой лопасти) Применение: Птз: К-700 Ямз: Ямз-238 НД,), Ямз-7511, Ямз-7511 (2005), Ямз-238 НД3, НД4, НД5 Характеристики: D=50мм',
    image:
      'photo/metall_tech_74/26_u9V0Mw1egJ4Za4h3FLfemckgQxqkY5tEHnVqqRbn294.jpg',
    vendor_code: '815577502314',
  },
  {
    price: '700000',
    name: 'Опорно-поворотное устройство опу d 1630 для кб-476',
    description:
      'Опорно-поворотное устройство d=1630 мм для башенного крана КБ-476.Характеристики: — диаметр 1630 мм.— внешнее зубчатое зацепление.— Количество зубьев z=133.— Модуль m=12.— Количество отверстий на венце и на внутреннем кольце 36 отв. D 33 мм.',
    image:
      'photo/metall_tech_74/34_hit7jWPRFP0rXPX-Z8qfB-OyWYMzUCh2fDScZxdgusk.jpg',
    vendor_code: '965057324937',
  },
  {
    price: '826000',
    name: 'Двигатель ямз-240бм2 №25',
    description:
      'Двигатель Ямз 240БМ2.— Производитель— Ямз.— Мощность— 220,6 (300) квт (л. С.).— Частота вращения— 1900/мин.— Максимальный крутящий момент— 1275 (130) Н. М. (Кгс. М).— Минимальный удельный расход топлива— 224 (165) г/квт. Ч (Г/л. С. Ч).',
    image:
      'photo/metall_tech_74/70_obO6E6NDx8GCX7DxAH42TjcCSAvqteszoDIcTOG-jhU.jpg',
    vendor_code: '859172956719',
  },
  {
    price: '970000',
    name: 'Двигатель ямз-65856',
    description:
      'Двигатель Ямз-65856. Характеристики: Мощность (номинал): 300 л. С. Габариты: 1425x1045x1100 мм. Масса: 1250 кг.',
    image:
      'photo/metall_tech_74/18_bqNTNwACZBNhCRLdQLZOuxaYtnDhQDFxt1DrYVCRZLo.jpg',
    vendor_code: '136040441178',
  },
  {
    price: '800000',
    name: 'Корпус ковша экг-4у',
    description: 'Корпус ковша Экг-4у.',
    image:
      'photo/metall_tech_74/78_g_vlD16fl8rg_kuuOMJHokyG2Y-9ja3swe7l3LRuvgE.jpg',
    vendor_code: '395564770796',
  },
  {
    price: '1200',
    name: 'Шлицевая кардан Урал ЗИЛ Газон Валдай',
    description:
      'Шлицевая чясть кардана приварная. Подходит на Зил, Маз зубренок, Камаз, Урал, Газон, Валдай итд.',
    image:
      'photo/metall_tech_74/14_mu1hapYM1QvZepavOEaftAwVbUJ5NIZwNn_zwozUjDo.jpg',
    vendor_code: '835596294885',
  },
  {
    price: '750000',
    name: 'Двигатель Д-180, Д-160 Новые',
    description:
      'Тип двигателя четырехтактный с турбонаддувом, 4-цилиндровый рядный.Диаметр цилиндра, мм150,0.Ход поршня, мм205,0.Рабочий объем, л14,48.Запас по крутящему моменту, %25.Удельный расход топлива, г/квт*ч (г/л. С. *ч)218 (160).Пуск дизеля от пускового двигателя (или электростартер).Масса с пусковым двигателем, кг 2095.Габариты, мм: - длина1730.- ширина1190.- высота1730.Двухступенчатый воздухоочиститель:— первая ступеньмультициклон с автоматическим удалением пыли;— вторая ступеньбумажные фильтрующие элементы. Система охлажденияжидкостнаясистема смазкикомбинированная с полнопоточным фильтром со сменными бумажными элементами.Мотор Д-180, Д180, Дизель Д180, Д-180.Д-160— 450 000.Д-180— 750 000.',
    image:
      'photo/metall_tech_74/8_kmgWKF8xjH30U24YTLACJW5K_0WS579GlfreT4_qECk.jpg',
    vendor_code: '820083576969',
  },
  {
    price: '980000',
    name: 'Мотор ямз-240нм2',
    description:
      'Мотор Ямз-240НМ2.-47 95 dsa f 56b 00 323 95 f dsa 56b 00 323.',
    image:
      'photo/metall_tech_74/12_kteFURF_GHRZ-7Sm2DjHXWN2bUgaFZt19UCNHJGEfoA.jpg',
    vendor_code: '252343466763',
  },
  {
    price: '1000000',
    name: 'Головные блоки экг-4у',
    description: 'Головные блоки Экг-4у.',
    image:
      'photo/metall_tech_74/0_m8kJR8iSGnTx1q2L-GyOdaWQDUy8FaT1HR1qAa03sPE.jpg',
    vendor_code: '953871834758',
  },
  {
    price: '850000',
    name: 'Двс cummins NTA 855-C360',
    description:
      'Двс Cummins Nta 855-C360.( наработка 1100мот/час) состояние нового.',
    image:
      'photo/metall_tech_74/57_RVpkH246901Bdf77fFbSYocZm6Enc7buvV_V6VPioIA.jpg',
    vendor_code: '935458164143',
  },
  {
    price: '700000',
    name: 'Кпп CAT D6R',
    description: 'Электронная кпп на Cat D6R, подойдёт и вместо механической.',
    image:
      'photo/metall_tech_74/30_bWNGUHsGkGTPecX_JLIrmQBt2r5paVsn-HD5iMfG8uA.jpg',
    vendor_code: '576542198429',
  },
  {
    price: '980000',
    name: 'Гусеница в сборе Т-330',
    description: 'Гусеница в сборе 46-22-17-02сп бульдозера Т-330.',
    image:
      'photo/metall_tech_74/15_XrAlBHhnuY2L8Sqpaxr9VgsZrDPKyMVzhW0OlwmS4qc.jpg',
    vendor_code: '627522004072',
  },
  {
    price: '2500',
    name: 'Лист рессоры N2 передней Газель 2-х листовой 3302',
    description: 'Лист рессоры N2 передней Газель 2-х листовой 3302.',
    image:
      'photo/metall_tech_74/15_PjHh6a-Y-akefAfaAzUboB6bnuR04T-M0-c2ipUsPPg.jpg',
    vendor_code: '649154339229',
  },
  {
    price: '990000',
    name: 'Маневровый гусек 1005.50.00.00 от крана мкгс-100',
    description: 'Мaневровый гуceк 1005.50.00.00 от кpана мкгс-100',
    image:
      'photo/metall_tech_74/5_DKn12LbRCEhUVhHjXfcn-xHaN1woCIGY7GgSyWx9UTw.jpg',
    vendor_code: '865742369746',
  },
  {
    price: '3800',
    name: 'Продам шкив',
    description:
      'шкивы на косилку, диаметр 300 мм. Нижний 130 мм. Посадочный диаметр М33 шаг 2 левая под ремень Б ( ширина 17 мм)',
    image:
      'photo/metall_tech_74/12_6rkBEVRT64O-rmcoJ6umkcsTS4nA7ioFt9vNv4XfNVU.jpg',
    vendor_code: '453234701430',
  },
  {
    price: '750000',
    name: 'Кпп Б12,Б11, Б10',
    description:
      'Кпп Б12, Б11 после кап. Ремонта. Под двигатель Ямз!114-12-1сп',
    image:
      'photo/metall_tech_74/11_9aQlzK_j5bd1OARGmYoTPozZOeeURnXdg0Y_GImvu6A.jpg',
    vendor_code: '391968361019',
  },
  {
    price: '1000',
    name: 'Стремянка перед XZU Hino Dutro Hino 300',
    description:
      'Ширина— 100.Длина— 135.Стремянка Xzu Hino Dutro Hino 300.Стремянка хино дутро хино 300.Стремянка хино дутро.Стремянка хино 300.',
    image:
      'photo/new_metall/64_gukOmYNFWlH2NMTkbrB8B_Io0Y_oavRVB25x5qWmZSY.jpg',
    vendor_code: '942446404066',
  },
  {
    price: '790',
    name: 'Диск стальной АКПП Komatsu 3EA1511180',
    description:
      'Диск стальной Акпп Komatsu 3EA1511180.Модель FD15-16 / FD15-17 / FD15-20 / FD15-21 / FD20-15 / FD20-16 / FD20-17 / FD25-15 / FD25-16 / FD25-17 / FD30-15 / FD30-16 / FD30-17 / Fd35a-16 / Fd35a-17 / FG15-16 / FG15-17 / FG15-20 / FG15-21 / FG20-12 / FG20-14 / FG20-16 / FG25-12 / FG25-14 / FG25-16 / FG30-12 / FG30-14 / FG30-16 / FD20-12 / FD20-14 / FD25-12 / FD25-14 / FD30-12 / FD30-14.',
    image: 'photo/new_metall/8_lPR4y1u1LzMPpWWKKvNbDh2QGKAJi5W_Iq-Za_F1_mg.jpg',
    vendor_code: '802543919414',
  },
  {
    price: '990000',
    name: 'Опорно-поворотное устройство (опу) на мкгс-100',
    description:
      'Опорно-поворотное устройство (Опу, опора роликовая) 977.00.10.00 в сборе (венец зубчатый 977.00.10.01, кольцо нажимное 977.00.10.02, кольцо опорное 977.00.10.03, крепежные болты 977.00.10.04, шарики H=44,45 H=76,20) на гусеничный кран Мкгс-100, Мкгс-100.1, Мкгс-125 Ульяновского завода. Оно работает в сопряжении с шестерней выходной 880.35.10.07, предназначено для опоры поворотной платформы и вращения крана вокруг своей оси, приводом служит редуктор поворота 915.30.51.00 с электродвигателя Дв22у2, 6 квт, 1100об/мин. Масса опорно-поворотного устройства составляет 3900 килограмм.',
    image:
      'photo/metall_tech_74/9_cLLKg9xdqXT9wXYwDIr4eL73QIDX8l2TtJAF9DJN09Q.jpg',
    vendor_code: '901308991753',
  },
  {
    price: '832000',
    name: 'Двигатель Д-245.30Е3-1442 маз Зубренок новый',
    description:
      'Двигатель Д-245.30Е3-1442 на Маз-4370 Зубренок! Заводская комплектация двигателя Д-245.30Е3-1442: — стартер: 7402.3708 (24В).— генератор: Aan 8171.— компрессор: А29.05.000-А-06.— насос топливный: 0 445 020 088.— турбокомпрессор: С15-505-01.— насос шестерённый: 14Г-3Л.— диск сцепления нажимной: MF362, 15 3482 1255 12.— диск сцепления ведомый: 362gtz, 38 1878 0793 02.— картер муфты сцепления: 245-1601312-05.',
    image:
      'photo/metall_tech_74/65_a4pXj4Tv1WvpQH58oND3Ve-yClkVUmgJkwQV85w4x8c.jpg',
    vendor_code: '407514977515',
  },
  {
    price: '3700',
    name: 'Зубья 81010600 Hidromek 100,102B,102S',
    description:
      'Зубья 81010600 Hidromek.Вес 3.5 кг.Применяемость: для экскаваторов-погрузчиков Hidromek 100 102B 102S.',
    image:
      'photo/metall_tech_74/7_E0Yg_0bSbOKHV0WqE1SWEpQDzhBPu1lKkN6YVpiG_pw.jpg',
    vendor_code: '058617588736',
  },
  {
    price: '750000',
    name: 'Гусеница болотоходная дст-Урал (20-22-3сп)',
    description:
      'Гусеница болотоходная Чтз, Дст-Урал.- 45 звеньев.- номер 20-22-3СП.',
    image:
      'photo/metall_tech_74/10_z14IJgG6uoveeRD-zx38DFc343NA7MA8ID2_v3b0eHY.jpg',
    vendor_code: '068252346409',
  },
  {
    price: '800',
    name: 'Габарит Mitsubishi Fuso Canter FE59E',
    description:
      'Габарит Mitsubishi Fuso Canter Fe59e.Габаритный огонь Mitsubishi Fuso Canter fe59e.Габарит митсубиси фусо кантер.Габаритный огонь мицубиси фусо кантер.',
    image:
      'photo/new_metall/61_Wxy3Bk5SaxY51b9lDVlpS7baP0IEgOw5nqNE-OmHf_g.jpg',
    vendor_code: '076363381728',
  },
  {
    price: '880000',
    name: 'Гусеница рмш',
    description: 'Газ 34036 34039.',
    image:
      'photo/metall_tech_74/48_UEjE2JwpOeYNtxNj8pomFeY7Q0-N7jwVkcZjZGyNlyw.jpg',
    vendor_code: '990970722089',
  },
  {
    price: '720000',
    name: 'Кабина Урал сдвоеная',
    description:
      'Новая заводская 2 х рядная кабина 4320 -1ой комплектации в комплекте с оперением( крыло левое, правое, капот, решотка радиатора, боковина капотта левая, правая, панель фары левая, правая, подкрылок левый, правый)! Цвет хаки.',
    image:
      'photo/metall_tech_74/20_EhLSMRbMm4Ozbj1RvJB7L0jadcse6uEzAnw8GuIBZGA.jpg',
    vendor_code: '809215014142',
  },
  {
    price: '990000',
    name: 'Кабина Renault T',
    description:
      'Кабина.Номер производителя: 7485143517.5600745671 7485143517.Кабина красная 2015 год, под автоматическую коробку передач, Акпп: AT2_12E.Сняты блоки управления! Стоимость указана за кабину без спойлеров и сидений!',
    image:
      'photo/metall_tech_74/6_iqBdPY8amy4AzLps_UPXqIlp2tFSfcZ7DCyDi0TZ0Hs.jpg',
    vendor_code: '731380783018',
  },
];
